import { render, staticRenderFns } from "./WorkspaceActions.vue?vue&type=template&id=57818dac"
import script from "./WorkspaceActions.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceActions.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports